import * as React from 'react';
import { useState } from 'react';
import { SuccessSendingEmailModal } from './SuccessSendingEmailModal';
import { PlansButtons } from './PlansButtons';

interface IProps {
    loading: boolean;
    handleCheckout: (p: any) => void;
}

const packagesData = [
    {
        stripePrice: process.env.REACT_APP_STRIPE_MONTHLY,
        packageTitle: 'Monthly',
        usersQuantity: 1,
        packageSubtitle: 'Most flexible option and cancel at any point',
        packageFrequency: 'month',
        pricePerUser: 0,
        checkoutPrice: 15,
        displayPrice: '15',
        features: [
            '10GB storage',
            'No watermark on export',
            'Unlimited Telestrations',
            'Online access from any device',
        ],
    },
    {
        stripePrice: process.env.REACT_APP_STRIPE_BI_ANNUALLY,
        packageTitle: 'Bi-Annually',
        usersQuantity: 1,
        packageSubtitle: '20% off monthly price when signing up for 6 months',
        packageFrequency: '6 months',
        pricePerUser: 0,
        checkoutPrice: 85,
        displayPrice: '13',
        features: [
            'Same access as monthly',
            'Get one month FREE',
        ],
    },
    {
        stripePrice: process.env.REACT_APP_STRIPE_ANNUALLY,
        packageTitle: 'Annually',
        usersQuantity: 1,
        packageSubtitle: '30% off monthly price when signing up for 12 months',
        packageFrequency: 'year',
        pricePerUser: 0,
        checkoutPrice: 149,
        displayPrice: '12',
        features: [
            'Same access as monthly',
            'Get two months FREE',
        ],
    },

    {
        stripePrice: process.env.REACT_APP_STRIPE_ANNUALLY,
        packageTitle: 'Multi-License',
        usersQuantity: 1,
        packageSubtitle: '30% off monthly price when signing up for 12 months',
        packageFrequency: 'year',
        pricePerUser: 0,
        checkoutPrice: 149,
        displayPrice: '12',
        features: [
            'Same access as monthly',
            'Get two months FREE',
        ],
    }
];

export const PackagesList = ({ loading, handleCheckout }: IProps) => {
    const [isModalOpened, setModalState] = useState(false);

    function handleChange() {
        setModalState((prev) => !prev);
    }

    return (
        <>
            {packagesData.map((packageData, index) => (
                <PlansButtons
                    key={index}
                    loading={loading}
                    handleCheckout={handleCheckout}
                    packageData={packageData}
                    openSuccessModal={handleChange}
                />
            ))}
            <SuccessSendingEmailModal
                open={isModalOpened}
                onClose={handleChange}
            />
        </>
    );
};
